/*=========================================================================================
  File Name: module-usertax-getters.js
  Description: UserTax Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	ConfirmVatRates(state) {
		return state.ConfirmVatRates;
	},
	Total(state) {
		return state.Total;
	},
	IsLoading(state) {
		return state.IsLoading;
	},
	ConfirmVatRate(state) {
		return state.ConfirmVatRate;
	}
};
